import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[color:var(--navy)] text-slate-300 mt-24">
    <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-9 h-9 rounded-lg btn-primary grid place-items-center"><Home className="w-5 h-5 text-white" /></span>
          <span className="font-display font-extrabold text-xl text-white">InspectorPro<span className="text-emerald-400">Leads</span></span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">Sacramento County & 60-mile radius. Connecting homeowners with verified home inspection, pest control, roofing, HVAC, general contractor & specialty inspection pros.</p>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Homeowners</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/quote" className="hover:text-emerald-400">Request a Quote</Link></li>
          <li><Link to="/directory" className="hover:text-emerald-400">Browse Directory</Link></li>
          <li><Link to="/how-it-works" className="hover:text-emerald-400">How It Works</Link></li>
          <li><Link to="/blog" className="hover:text-emerald-400" data-testid="footer-blog-link">Blog & Guides</Link></li>
          <li><Link to="/services" className="hover:text-emerald-400" data-testid="footer-services-link">Service Areas</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">For Pros</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/pricing" className="hover:text-emerald-400">Membership Plans</Link></li>
          <li><Link to="/dashboard" className="hover:text-emerald-400">Pro Dashboard</Link></li>
          <li><Link to="/pricing" className="hover:text-emerald-400">Lead Credits</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Service Area</h4>
        <p className="text-sm text-slate-400 leading-relaxed">Sacramento, Roseville, Folsom, Elk Grove, Davis, Citrus Heights, Rocklin, Woodland, Rancho Cordova & more.</p>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="container-x py-6 text-sm text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} InspectorProLeads. All rights reserved.</span>
        <span>Serving the Greater Sacramento Region</span>
      </div>
    </div>
  </footer>
);
